import type { Quote } from '@exodus/fiat-ramp/api';
import { formatPriceUSD } from '@exodus/formatting/lib/price';
import { VALIDATION_TYPES } from '@exodus/send-validation/src/constants';

import { createValidationHookWithDefaults } from '@/ui/utils/validation';
import type { FormValidation } from '@/ui/utils/validation';

type BuyFormValidationDependencies = {
  amount: number;
  loadingQuote: boolean;
  quote?: Quote;
};

const minAmountValidation = {
  id: 'MIN_AMOUNT',
  type: VALIDATION_TYPES.ERROR,
  shouldValidate: ({ quote, loadingQuote }) =>
    !loadingQuote && !!quote?.from.minBuyAmount,
  isValid: ({ quote, amount }) => quote && amount >= quote.from.minBuyAmount,
  getMessage: ({ quote }) =>
    quote &&
    `Amount must not be smaller than ${formatPriceUSD(`${quote.from.minBuyAmount}`)}.`,
} as FormValidation<BuyFormValidationDependencies>;

const maxAmountValidation = {
  id: 'MAX_AMOUNT',
  type: VALIDATION_TYPES.ERROR,
  shouldValidate: ({ quote, loadingQuote }) =>
    !loadingQuote && !!quote?.from.maxBuyAmount,
  isValid: ({ quote, amount }) => quote && amount <= quote.from.maxBuyAmount,
  getMessage: ({ quote }) =>
    quote &&
    `Amount must not be larger than ${formatPriceUSD(`${quote.from.maxBuyAmount}`)}.`,
} as FormValidation<BuyFormValidationDependencies>;

const validations = [minAmountValidation, maxAmountValidation];

const useBuyFormValidation =
  createValidationHookWithDefaults<BuyFormValidationDependencies>({
    customValidations: validations,
    globalValidations: [],
  });

export default useBuyFormValidation;
